import { IApplicationState } from '../../../../../../types/types';

export const getReplyText = (state: IApplicationState): string => {
    return state.comments.replyText;
}
